import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/base/Portal';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
//import moment from 'moment';
import axios from 'axios';

import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const userObj = useSelector(state => state.userDetails);
  const [formReset, setFormReset] = React.useState(false);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [browseFilePath, setBrowseFilePath] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setFormReset(!formReset);
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setSaveLoading(false);
    setBrowseFilePath("");

	}, [open]);
  
  
	function saveData(){

    var browseFile = document.querySelector('#attachfile');

    if(browseFile && browseFile.files[0] && browseFile.files[0].name.length>0){

      let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': userObj.registerId,
          'uid': userObj.loginId,
          'fullName': userObj.fullName,
          'token': userObj.token,
        }
      };

      const data = new FormData();
			data.append("uploadedFiles", browseFile.files[0]);

      setSaveLoading(true);       
			axios.post(API_URL+'/crm-upload-accounts', data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);    
        setBrowseFilePath("");    
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setFormReset(!formReset);
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Data has been uploaded.");
          props.updatedList();
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Data could not be uploaded.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}


  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>Upload CSV File for Accounts Creation</h4></div>

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                          <Grid item md={12} xs={12} >
                              <input 
                                type="file" 
                                id="attachfile"
                                onChange={event => setBrowseFilePath(event.target.value)}
                                />
                              <br/><b>CSV Columns Order:</b> company, address, contactName, phone, mobile, email, website, gstNumber, panNumber, consigneeCode
                          </Grid>

                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>

                          {(browseFilePath && browseFilePath.length>0)?  
                            saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Uploading...</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Upload</Button>
                          :null}  
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

    </>
  );

});

export default CustomizedDialogs;